import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import {
  Button,
  Checkbox,
  Chip,
  FormControlLabel,
  TextField,
} from '@material-ui/core';
import { BonusProductTypeText } from '../../data/common';
import LocationOnRoundedIcon from '@material-ui/icons/LocationOnRounded';

const useStyles = makeStyles({
  packageProduct: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    alignItems: 'stretch',
    flex: '1 1 100%',
    backgroundColor: '#f8f8f8',
    padding: '12px',
    borderRadius: '6px',
    margin: '4px 0',
  },
  packageProductImg: {
    alignContent: 'center',

    '& > img': {
      width: '110px',
      objectFit: 'cover',
      borderRadius: '12px',
    },
  },
  packageProductContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '6px',
    fontSize: '1rem',
    fontWeight: '500',
  },
  packageProductBtns: {
    marginLeft: 'auto',
    alignContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    gap: '6px',
    backgroundColor: '#fff',
    padding: '6px 12px',
    borderRadius: '6px',
  },
  tags: {
    display: 'flex',
    gap: '12px',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  expriyDayDesc: {
    fontSize: '0.8rem',
    fontWeight: '500',
    color: '#f36363',
    lineHeight: '1.5',
    letterSpacing: '1px',
  },
});

const AddProductCard = (props) => {
  const classes = useStyles();
  const { product, addProduct, isLoading } = props;
  const [count, setCount] = useState();
  const [isGift, setIsGift] = useState(false);
  const [expriyDay, setExpriyDay] = useState();

  const handleAddProduct = () => {
    addProduct(product.id, isGift, count, expriyDay);
  };

  return (
    <div className={classes.packageProduct}>
      <div className={classes.packageProductImg}>
        {product.mainImage && <img src={product.mainImage.imageName} />}
      </div>

      <div className={classes.packageProductContent}>
        <div>{product.name}</div>

        <div className={classes.tags}>
          <Chip
            variant="outlined"
            size="small"
            color="primary"
            label={BonusProductTypeText[product.type]}
          />

          <Chip
            variant="outlined"
            size="small"
            color="default"
            icon={<LocationOnRoundedIcon />}
            label={product.storeInfo ? product.storeInfo.name : '不限分店'}
          />
        </div>
      </div>

      <div className={classes.packageProductBtns}>
        <div>
          <TextField
            variant="outlined"
            size="small"
            value={count || ''}
            onChange={(e) => {
              const value = e.target.value;

              if (/^[0-9]*$/.test(value)) {
                setCount(value);
              }
            }}
            label="數量"
            disabled={isLoading}
            style={{ marginRight: '12px' }}
          />

          <FormControlLabel
            label="贈品"
            control={
              <Checkbox
                checked={isGift}
                onChange={(e) => {
                  setIsGift(e.target.checked);
                }}
                disabled={isLoading}
              />
            }
          />
        </div>

        <TextField
          variant="outlined"
          size="small"
          value={expriyDay || ''}
          onChange={(e) => {
            const value = e.target.value;

            if (/^[0-9]*$/.test(value)) {
              setExpriyDay(value);
            }
          }}
          label="贈品使用期限(天)"
          disabled={isLoading || !isGift}
        />

        <div className={classes.expriyDayDesc}>
          使用期限說明:
          <br />
          不是贈品: 一律視為無限期 <br />
          贈品: 可設定使用期限(天)，未設定視為無限期
        </div>

        <Button
          variant="contained"
          size="small"
          color="primary"
          startIcon={<AddCircleOutlineRoundedIcon />}
          onClick={handleAddProduct}
          disabled={isLoading || !count || count <= 0}>
          新增
        </Button>
      </div>
    </div>
  );
};

export default AddProductCard;
